import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=65d4d5de&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"
import style0 from "./Client.vue?vue&type=style&index=0&id=65d4d5de&prod&lang=css"
import style1 from "./Client.vue?vue&type=style&index=1&id=65d4d5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4d5de",
  null
  
)

export default component.exports